import { useQuery } from '@tanstack/react-query';
import * as http from 'util/elemental_axios_client';

export const useJourney = (id, options ) => {
    return useQuery(['journeys', id], async () => {
        return await http.get(`/flows/${id}`);
    }, options);
};

export const useJourneyStepStats = (id, stepId) => {
    const action = `/flows/${id}/steps/${stepId}/stats`;

    return useQuery(['journey_step_stats', stepId], async () => {
        return await http.get(action);
    });
};

export const useJourneyStep = (id, stepId) => {
    const action = `/flows/${id}/steps/${stepId}`;

return useQuery(['journey_step', stepId], async () => {
        return await http.get(action);
    });
};


export const useJourneyVersions = (id) => {
    return useQuery(['journeys', id, 'versions'], async () => {
        return await http.get(`/flows/${id}/versions`);
    });
};

export const useAdjacencyListVersion = (id, version, options = {}) => {
    return useQuery(['journeys', id, 'adjacencyList', 'version', version], async () => {
        return await http.get(`/flows/${id}/versions/${version}/adjacency_list`);
    }, {
        enabled: !!version,
        ...options
    });
};
